/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestFullResponse } from '../../models/harvest-full-response';

export interface GetLastHarvestsForFacilityGroup$Params {
  facilityGroupId: number;
}

export function getLastHarvestsForFacilityGroup(http: HttpClient, rootUrl: string, params: GetLastHarvestsForFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestFullResponse>>> {
  const rb = new RequestBuilder(rootUrl, getLastHarvestsForFacilityGroup.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestFullResponse>>;
    })
  );
}

getLastHarvestsForFacilityGroup.PATH = '/api/harvests/facilityGroupId/{facilityGroupId}/last';
